import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { Translate } from 'react-localize-redux';

import { rgba } from 'polished';
import styled from 'styled-components';

import AppState from '@webapp/store/state';
import { CloseMenu } from '@webapp/store/ui/action-creators';

import NewMenu from '@components/new-menu';
import Grid from '@components/basics/grid';
import Button from '@components/actions/button';
import Typography from '@components/basics/typography';
import SquareImg from '@components/basics/artwork-img';
import UserAvatarInfo from '@components/basics/user-avatar-info';
import CatalogRelease from '@common/types/catalog/catalog-release';

interface ReleaseApprovedPageProps {
  className?: string;
  avatar?: string;
  fullName?: string;
  isMobile?: boolean;
  release?: CatalogRelease;
  noButton?: boolean;
  closeMenu: () => CloseMenu;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
  avatar: state.artist.active?.avatar,
  fullName: state.artist.active?.name,
  release: state.notifications.popupNotificationPayload as CatalogRelease,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeMenu: () => dispatch(new CloseMenu(undefined, true)),
});

const ReleaseApprovedMenu = (props: ReleaseApprovedPageProps) => {
  return (
    <NewMenu
      className={props.className}
      menuId="RELEASE_APPROVED_MENU"
      centeredPadding={!props.isMobile}
      noButton
      topHeader={
        props.isMobile &&
        props.avatar && (
          <UserAvatarInfo src={props.avatar} name={props.fullName!} />
        )
      }
      header={
        !props.isMobile &&
        props.avatar && (
          <UserAvatarInfo src={props.avatar} name={props.fullName!} />
        )
      }
      footer={
        <Button fullWidth onClick={props.closeMenu}>
          <Translate id="COMMON.DONE" />
        </Button>
      }
    >
      <Grid>
        <WrapperImg className="mb-30">
          <SquareImg className="artwork" srcImg={props.release?.cover_url} />
        </WrapperImg>

        <InfoWrapper>
          <Typography className="mb-20" type="subheader" customFont="semi-bold">
            <Translate
              id="RELEASE.RELEASE_ACCEPTED_MENU.TITLE"
              data={{ releaseName: props.release?.title }}
            />
          </Typography>
          <Text>
            <Translate id="RELEASE.RELEASE_ACCEPTED_MENU.TEXT1" />
            <a
              target="blank"
              style={{ fontWeight: 'normal', color: 'blue' }}
              href={props.release?.tracLink}
            >
              <Translate id="RELEASE.RELEASE_ACCEPTED_MENU.TEXT2" />
            </a>
            <Translate id="RELEASE.RELEASE_ACCEPTED_MENU.TEXT3" />
          </Text>
        </InfoWrapper>
      </Grid>
    </NewMenu>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReleaseApprovedMenu);

const WrapperImg = styled.div`
  width: 144px;
  height: 144px;
  aspect-ratio: 1/1;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.border};

  .artwork {
    width: 144px;
    height: 144px;
    margin: 0 auto;
    display: block;
    aspect-ratio: 1/1;
    ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
      margin: 0;
    }
  }
`;

const Text = styled(Typography)`
  color: ${({ theme }) => rgba(theme.colors.primary, 0.5)};
`;

const InfoWrapper = styled.div`
  ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
    display: flex;
    flex-direction: column;
  }
`;
